import { createFileRoute } from "@tanstack/react-router";
import { CompareHub } from "./jamfor.index";

const TITLE = "Compara sitios para vender de segunda mano | Sellavo";
const DESCRIPTION =
  "¿Blocket, Tradera, Facebook Marketplace o Sellpy? Compara cómo funcionan y cuándo Sellavo encaja mejor.";

export const Route = createFileRoute("/es/comparar")({
  loader: async () => {
    const { COMPARISONS } = await import("@/lib/jamforelser");
    return {
      items: COMPARISONS.map((c) => ({ slug: c.slug, h1: c.h1, description: c.description })),
    };
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/comparar" }],
  }),
  component: CompareHub,
});
